import { Box, MenuItem, Select, Typography } from "@mui/material";
import { incomeTaxClientTasks } from "api/services/automation/config";
import DialogWrapper from "components/DialogWrapper";
import { useQuery } from "react-query";
import { ResType } from "types";
import Table from "components/Table";
import { useState } from "react";
import moment from "moment";
import PriorityText from "components/PriorityText";
import { getTitle } from "utils";
import Members from "components/Members";
import { useNavigate } from "react-router-dom";

interface CatDetails {
  categoryId?: number;
  subCategoryId?: number;
}
interface Client {
  id: number;
  [key: string]: any
}

interface ClientTaskViewProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  catDetails: CatDetails;
  title: string;
  client: Client;
}

function ClientTaskView({ open, setOpen, catDetails, title, client }: ClientTaskViewProps) {
  const { categoryId, subCategoryId } = catDetails
  const [page, setPage] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const navigate = useNavigate()
  const { data, isLoading }: ResType = useQuery(["incometaxClientTask",
    {
      clientId: client?.id,
      categoryId,
      subCategoryId,
      limit: pageCount,
      offset: page * pageCount,
    }],
    incomeTaxClientTasks, {
    onSuccess: (res) => {
      setTotalCount(res?.data?.count);
    },
    enabled: open
  })

  let columns = [
    {
      key: "taskNumber",
      title: "Task ID",
    },
    {
      key: "name",
      title: "Task Name"
    },
    {
      key: "financialYear",
      title: "Financial Year"
    },
    {
      key: "dueDate",
      title: "Due Date",
      width: "200px",
      sort: true,
      active: false,
      default: true,
      render: (row) => {
        return row?.dueDate ? moment(row?.dueDate).format("DD-MM-YYYY") : "";
      },
    },
    {
      key: "priority",
      title: "Priority",
      active: false,
      default: true,
      render: (v) => (
        <Box display='flex'>
          <PriorityText text={v?.priority} />
          {getTitle(v?.priority)}
        </Box>
      ),
    },
    {
      key: "status",
      title: "Status",
      sort: true,
      active: false,
      default: true,
      render: (v) => (
        <Typography variant="h6" style={{ fontSize: '14px' }}>
          <Select
            value={v?.status}
            // onChange={(e) => handleStatusUpdate(e, v)}
            onClick={(e) => e.stopPropagation()}
            sx={{ height: '40px', width: '150px', textAlign: 'center' }}
            disabled
          >
            <MenuItem value="todo">Todo</MenuItem>
            <MenuItem value="in_progress">In Progress</MenuItem>
            <MenuItem value="on_hold">On Hold</MenuItem>
            <MenuItem value="under_review">Under Review</MenuItem>
            <MenuItem value="completed">Completed</MenuItem>
          </Select>
        </Typography>
      ),
    },
    {
      key: "Memberss",
      title: "Members",
      render: (v) => (
        <Members
          data={v?.members?.map((item: any) => ({
            title: item?.fullName,
            src: item?.imageStorage?.fileUrl
          }))}
        />
      ),
    },

  ];

  return (
    <DialogWrapper width="lg" open={open} setOpen={setOpen} title={title}>
      <Table
        sx={{ pb: 0, mb: 0, height: '470px' }}
        pagination={{ totalCount, pageCount, setPageCount, page, setPage }}
        data={data?.data?.data || []}
        columns={columns}
        loading={isLoading}
        onRowClick={(v) => v?.client ? navigate(`/task-board/${v?.id}/?clientId=${v?.client?.clientId}`) : navigate(`/task-board/${v?.id}/?clientGroupId=${v?.clientGroup?.clientId}`)}
      />
    </DialogWrapper>
  )
}

export default ClientTaskView